// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1HxDL","title":"styles_title__1B5Eb","input":"styles_input__1n_H9","newTeam":"styles_newTeam__Q6Be4"};